export interface LogDownload {
  url: string;
  label: string;
  isZip: boolean;
  fileCount: number;
}

/**
 * Chooses what the Remote Control modal offers after a kiosk finishes an UPLOAD_LOGS / UPLOAD_POS_LOGS command.
 * The kiosk zips every log file of the requested day (a day can have several size-rolled files) and reports
 * `zipUrl`, `zipFileName` and `logFileCount`; older kiosks only report the single file in `logUrl`/`fileName`.
 */
export function resolveLogDownload(command: string, data: any): LogDownload | null {
  if (command !== 'UPLOAD_LOGS' && command !== 'UPLOAD_POS_LOGS') return null;
  if (!data) return null;

  if (command === 'UPLOAD_LOGS' && typeof data.zipUrl === 'string' && data.zipUrl) {
    const count = Number(data.logFileCount) > 0 ? Number(data.logFileCount) : 1;
    const name = data.zipFileName || 'logs.zip';
    return {
      url: data.zipUrl,
      label: count === 1 ? `Download ${name} (1 log file)` : `Download ${name} (${count} log files)`,
      isZip: true,
      fileCount: count
    };
  }

  if (typeof data.logUrl === 'string' && data.logUrl) {
    return {
      url: data.logUrl,
      label: data.fileName ? `Open ${data.fileName}` : 'Open log',
      isZip: false,
      fileCount: 1
    };
  }
  return null;
}
